module.exports = __webpack_public_path__ + "img/SKMJ_safety.e34affb9.jpg";